<template>
  <div class="promo-code-wrapper">
    <div class="promo-code-card">
      <h4 class="font-size-12">{{ data.promo_code }}</h4>
      <p class="font-size-12">{{ promoCodeAmount() }}</p>
      <i class="remove-promo-code" @click="removePromoCode(data.promo_code)"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";

.promo-code-wrapper {
  .promo-code-card {
    background: $secondaryGrey;
    padding: 8px 16px;
    border-radius: 4px;
    position: relative;
    p {
      font-family: NHaasGroteskDSPro-55Rg;
      color: $secondaryGrey4;
    }

    .remove-promo-code {
      background: url("../../../assets/img/icons/clear.svg") no-repeat center;
      background-size: contain;
      height: 24px;
      width: 24px;
      display: block;
      position: absolute;
      top: 4px;
      right: 4px;

      &:hover {
        cursor: pointer;
        opacity: 0.9;
      }
    }
  }
  .discount {
    margin-top: 16px;
  }
}
</style>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    removePromoCode: {
      type: Function,
      default: (promoCode) => {},
      required: true,
    },
  },
  methods: {
    promoCodeAmount,
    getAmount,
    isFreeShipping,
  },
};

function isFreeShipping() {
  return this.data?.promo_code_type === "FREE_SHIPPING";
}

function promoCodeAmount() {
  if (this.isFreeShipping()) {
    return this.data.admin_promo_code ? "Free shipping up to $100 per order." : "Free shipping promo code applied.";
  } else {
    return `${this.getAmount()} off`;
  }
}

function getAmount() {
  const { promo_code_amount } = this.data;
  return `$${promo_code_amount.toFixed(2)}`;
}
</script>
